import React from "react";
import { useNavigate } from "react-router-dom";
import { verifyDriverDoc } from "../../Services/admin-service";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

const AcceptDoc = (props) => {

    const documentId = props.docId
    const navigate = useNavigate();

    const handleClick = () => {

        const payload = {
            documentId,
            action: "accept"
        }

        verifyDriverDoc(payload)
            .then((res) => {
                const nowDocs = props.docVals.filter(val => val._id != documentId)
                props.onSetDriverDoc(nowDocs)
                toast.success("Driver Document Accepted", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            })
            .catch((err) => {
                toast.error(err.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                console.log(err)
            })
    }

    return (
        <>
            <ToastContainer />
            <button className="btn btn-secondary" onClick={handleClick}>Accept</button>
        </>
    )
}

export default AcceptDoc